/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_EyebrowInputs */

const en_hero_eyebrow = /** @type {(inputs: Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexxt · the B2B platform of Tomorrow`)
};

/**
* | output |
* | --- |
* | "Nexxt · the B2B platform of Tomorrow" |
*
* @param {Hero_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hero_eyebrow = /** @type {((inputs?: Hero_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hero_eyebrow(inputs)
});